import { FC } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Text,
  VStack,
  Flex,
  Icon,
} from "@chakra-ui/react";
import { IconLock } from "@tabler/icons-react";
import { Button } from "@Components/Button";

interface AcessoNegadoModalProps {
  isOpen: boolean;
  onClose: () => void;
  // Textos opcionais — cada contexto (fluxo negado / estudo sem acesso) passa o seu.
  titulo?: string;
  mensagem?: string;
  // Rótulo do botão (ex.: "Entendi" p/ ação; "Voltar" quando fechar navega de volta).
  botaoLabel?: string;
}

/**
 * Aviso de ACESSO NEGADO (403) em MODAL CENTRALIZADO, alto contraste, que bloqueia a
 * tela e exige o fechamento — substitui o toast (top-right, some em 5s, baixa
 * legibilidade). Reutilizado nas 403 de fluxo (ação sem papel) e de estudo/arquivo
 * (abrir estudo de tipo sem papel). É só UX; o enforcement real é no backend.
 */
export const AcessoNegadoModal: FC<AcessoNegadoModalProps> = ({
  isOpen,
  onClose,
  titulo = "Sem acesso a este fluxo",
  mensagem = "Sua conta não tem o papel necessário para esta ação. Peça a liberação ao administrador.",
  botaoLabel = "Entendi",
}) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay bg="blackAlpha.600" />
    <ModalContent fontFamily="body" borderRadius="16px" mx="16px">
      <ModalBody pt="28px" pb="8px">
        <VStack spacing={4} textAlign="center">
          <Flex
            align="center"
            justify="center"
            boxSize="52px"
            borderRadius="full"
            bg="states.error.lighter"
          >
            <Icon as={IconLock} boxSize={6} color="states.error.base" />
          </Flex>
          <Text fontFamily="heading" fontSize="18px" fontWeight="600" color="neutrals.text.strong-950">
            {titulo}
          </Text>
          <Text fontSize="sm" color="neutrals.text.sub-600">
            {mensagem}
          </Text>
        </VStack>
      </ModalBody>
      <ModalFooter justifyContent="center" pb="24px">
        <Button colorSchema="brand" variant="solid" onClick={onClose}>
          {botaoLabel}
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
